import { UserConstants } from '../constants';

let userToken = localStorage.getItem('userToken');
const initialState = userToken ? { loggedIn: true, loggingIn: false } : { loggedIn: false, loggingIn: false};


export function authentication(state = initialState, action) {
    switch (action.type) {
    case UserConstants.LOGIN_REQUEST:
        return {
            loggingIn: true,
            
        };
    case UserConstants.LOGIN_SUCCESS:
        return {
            userResponse: action.payload.data,
            loggedIn: true,
            loggingIn: false,
        };
    case UserConstants.LOGIN_FAILURE:
        return {};
    case UserConstants.LOGOUT:
        return {
            loggedIn :false,
            loggingIn: false
        };
    default:
        return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/AuthReducer.jsx